const pt = {
  translation: {
    dashboard: 'Dashboard',
    de: 'de',

    no_tipo_recurso: 'Nenhum recurso deste tipo foi baixado',
    no_tipo_agrupacion: 'Nenhum grupo deste tipo foi baixado',

    OBJECT_TYPE_Recurso: 'Recurso',
    OBJECT_TYPE_Agrupacion: 'Grupo',

    cantidad_recursos: 'Recursos nesta coleção',

    //info del rankin
    posicion: 'Posição',
    titulo: 'Título',

    //footer
    contacto: 'Contato',
    linea_nacional:
      'Linha nacional: 01-8000-51-0258, Linha em Bogotá: 4890400',
    horario_atencion:
      'Horário de atendimento: segunda a sexta-feira - 8:00 da manhã às 17:00',
    derechos_reservados: 'Todos os direitos reservados',

    Textual: 'Textos',
    Software: 'Software',
    Interactivo: 'Interativo',
    Grafico: 'Imagens',
    Sonoro: 'Áudios',
    Audiovisual: 'Vídeos',
    Multimedia: 'Multimídia',

    calificacion: 'Qualificação',
    catalogo: 'Catálogo',

    //Descripcion recurso
    comentario: 'Comentários',
    no_comentarios: 'Este recurso não possui comentários',
    califica_recurso: 'Classifique este recurso',
    agregar_favoritos: 'Adicionar aos favoritos',
    palabra_clave: 'Palavras-chave',
    publico_objetivo: 'Público-alvo',
    tipo_contenido: 'Tipo de conteúdo',
    autores: 'Autores',
    licenciante: 'Licenciante',
    sugerencia_uso_pedagogico: 'Sugestão de uso pedagógico',
    descripcion: 'Descrição',
    recursos_relacionados: 'Recursos relacionados',
    opciones: 'Ver opções',
    ingresar_colombia_aprende:
      'Para adicionar o recurso aos Favoritos, você precisa fazer login com sua conta do portal',
    colombia_aprende: 'Colombia Aprende',
    iniciar_sesion_registro: 'Login ou Registrar',

    //Landing
    contenidos_destacados: 'Conteúdos ressaltados',
    landing_mensaje:
      'O Ministério da Educação Nacional da Colômbia disponibiliza às instituições educativas, estudantes, educadores e ao público em geral, através do Catálogo de Recursos Educativos Digitais (RED Aprende), uma ampla gama de recursos educativos digitais.',
    nuevos_recursos: 'Novos Recursos',
    recursos_colecoes_mas_vistas: 'Recursos e coleções mais vistas',

    //header
    header_agrupaciones: 'Agrupamentos',
    header_recursos: 'Recursos',

    //aside
    aside_descargas: 'Downloads',
    aside_ajustes: 'Configurações',

    explorar: 'Explorar',

    todas: 'Tudos',
    agregacion: 'Colecção',
    destilacion: 'Ranking',
    cronologia: 'Linha do tempo',

    tipo_agrupacion: 'Tipo de agrupamento',
    buscar_agrupacione_descargas: 'Pesquisar agrupamentos',

    landing_no_resultados:
      'Desculpe, nenhum resultado de pesquisa encontrado!',
    landing_tipo_contenido: 'Tipo de Conteúdo',
    selecciona: 'Selecione',

    poblacion_objetivo: 'População alvo',
    nivel_educacional: 'Nível educacional',
    nucleo_basico: 'Núcleo de Conhecimento Básico',
    compartir_facebook: 'Compartilhar em Facebook',
    compartir_twitter: 'Compartilhar em Twitter',
    compartir_whatsapp: 'Compartilhar em WhatsApp',
    tipo_licenca: 'Tipo de licença',

    toast_guardado: 'Guardado com sucesso!',
    toast_descargado_prev: 'Recurso baixado anteriormente',
    toast_eliminado: 'Recurso removido com sucesso',
    toast_completar_accion: 'Ação não pôde ser concluída',
    toast_descarg_iniciada: 'Download em progresso',
    toast_descarga_finalizada: 'Download concluído',
    toast_descarga_error: 'Ocorreu um erro, tente novamente',

    panel_minimizar: 'Minimizar painel',
    panel_maximizar: 'Maximizar painel',

    dl_desc_recurso: 'Recurso',

    dl_element_borrar: 'Excluir recurso',
    dl_element_ver: 'Ver informação',

    empty_para_descargar: 'Para baixar recursos, vá para',
    empty_no_descargas: 'Você não baixou recursos',
    empty_para_descarga_agrupaciones: 'Para baixar agrupamentos, vá para',
    empty_no_descargas_agrupaciones: 'Você não baixou agrupamentos',

    header_cambiar_idioma: 'Mudar idioma',
    header_mis_agrupaciones: 'Meus agrupamentos',

    landing_resultados_encontrados: 'Resultados encontrados por',
    landing_reiniciar_busqueda: 'Resetar pesquisa',
    landing_filtrar: 'Filtrar',
    landing_limpiar_filtros: 'Limpar',
    landing_tipos_recurso: 'Tipos de recurso',
    landing_formatos: 'Formatos',
    landing_dificultad: 'Dificuldade',
    landing_nivel_educacional: 'Nível educacional',
    landing_area_conocimiento: 'Áreas de conhecimento',
    landing_filtros: 'Filtros',

    imagenes: 'Imagens',
    videos: 'Vídeos',
    documentos: 'Documentos',
    audio: 'Áudio',
    otros: 'Outros',
    todos: 'Todos',

    inicio: 'Inicio',
    descargas: 'Meus Downloads',
    buscar: 'Pesquisar',
    espanol: 'ES',
    ingles: 'EN',
    guardar_recurso: 'Salvar recurso',
    descargar_recurso: 'Baixar recurso',
    acerca: 'Sobre',
    licenca: 'Licença',
    documentacao: 'Documentação',
    ver_nueva_pestana: ' Abrir em nova guia',
    compartilhar: 'Compartilhar',

    modal_eliminar_titulo: 'Excluir',
    modal_eliminar_mensaje:
      'Você tem certeza de que deseja remover o recurso  ',
    modal_eliminar_cancelar: 'Cancelar',
    modal_eliminar_borrar: 'EXCLUIR',

    buscar_descargas: 'Pesquisar downloads',
    borrar: 'Excluir',
    info: 'Informações do recurso',
    recurso_descargado: 'Recurso baixado',
    descargar: 'Baixar',
    downloaded: 'Baixado',

    portugues: 'PT',

    header_colecciones: 'Colecções',
    sin_colecciones_para_mostrar: 'Não há coleções para mostrar na seção.',
    ir_a_coleccion: 'Ir para a coleção',
    ver_comentarios: 'Ver comentários',
    recursos_mejor_puntuados: 'Recursos mais bem avaliados',
    visualizacion_no_disponible: 'A exibição do recurso não está disponível',

    // Textos de Header.js
    header_site_title: 'RED Aprende',
    header_govco_title: 'GOV.CO',
    header_login: 'Fazer login',
    header_language: 'Idioma',
    header_favorites: 'Favoritos',
    header_loading: 'carregando...',
    header_spanish: 'Espanhol',
    header_english: 'Inglês',
    header_portuguese: 'Português',
    header_govco_nav_aria: 'Navegação principal Gov.co',
    header_login_aria: 'Fazer login na plataforma',
    header_spanish_aria: 'Selecionar idioma espanhol',
    header_english_aria: 'Selecionar idioma inglês',
    header_portuguese_aria: 'Selecionar idioma português',
    header_main_nav_aria: 'Navegação principal do site',
    header_main_menu_aria: 'Menu principal do aplicativo',
    header_home_link_aria: 'Ir para a página inicial',
    buscador_aria: 'Campo de busca por palavra-chave',
    buscar_aria: 'Botão para iniciar a busca',
    header_collections_aria: 'Ir para a seção de coleções',
    header_favorites_aria: 'Ver recursos favoritos',

    // Textos de Footer.js
    footer_red_aprende: 'RED Aprende',
    footer_collections: 'Coleções',
    footer_data_treatment: 'Tratamento de dados pessoais',
    footer_privacy_terms: 'Privacidade e termos de uso',
    footer_digital_security: 'Segurança digital',
    footer_cookies: 'Cookies',
    footer_educational_level: 'Nível Educacional',
    footer_first_child_hood: 'Primeira infância',
    footer_preschool_basic_media: 'Pré-escola, ensino básico e médio',
    footer_superior_education: 'Educação superior',
    footer_work_human_development_education: 'Educação para o trabalho e desenvolvimento humano',
    footer_areas_subjects: 'Áreas e assuntos',
    footer_science_math: 'Ciências e matemática',
    footer_language_humanities_society: 'Linguagem, humanidades e sociedade',
    footer_art_culture_expression: 'Arte, Cultura e Expressão',
    footer_physical_education: 'Educação física, recreação e esportes',
    footer_health_wellness: 'Saúde e bem-estar',
    footer_healthy_habits: 'Promova hábitos saudáveis e bem-estar integral',
    footer_external_links: 'Links externos',
    footer_currideas: 'CurrIdeas',
    footer_colombia_aprende_link: 'Colômbia Aprende',
    footer_mineducacion_title: 'Ministério da Educação Nacional',
    footer_address_label: 'Endereço:',
    footer_address_value: 'Rua 43 No. 57 - 14. CAN. Bogotá, Colômbia. Código Postal 111321.',
    footer_phone_conmutator_label: 'Telefone da Central:',
    footer_phone_conmutator_value: '(601) 22 22800',
    footer_free_line_label: 'Linha gratuita fora de Bogotá:',
    footer_free_line_value: '018000 - 510258',
    footer_attention_schedule_label: 'Horário de funcionamento',
    footer_attention_schedule_value: 'Segunda a quinta-feira, das 8h00 às 17h00, e sexta-feira, das 7h00 às 16h00. Jornada contínua.',
    footer_tech_support_label: 'Suporte técnico - Sistemas de informação. Telefone:',
    footer_tech_support_value: '(601) 432 1215',
    footer_national_free_line: 'Linha gratuita nacional',
    footer_anti_corruption_email_label: 'Email anticorrupção:',
    footer_judicial_notifications_email_label: 'Email para notificações judiciais:',
    footer_channels_attention: 'Canais físicos e eletrônicos para atendimento ao público',
    footer_social_networks: 'Redes sociais',
    footer_interest_links: 'Links de interesse',
    footer_terms_conditions_aria: 'Termos e condições',
    footer_policies_aria: 'Políticas',
    footer_sitemap_aria: 'Mapa do site',
    footer_accessibility_aria: 'Acessibilidade',
    footer_administration_aria: 'Ir para a página de administração',
    footer_colombia_aprende_link_bottom_aria: 'Abrir link da plataforma Colombia Aprende',

    // Textos de Accessibility.js
    accessibility_contrast: 'Contraste',
    accessibility_reduce_letter: 'Reduzir letra',
    accessibility_increase_letter: 'Aumentar letra',

    // Textos de Landing.js
    landing_banner_title: 'Explore e ensine com RED Aprende',
    landing_banner_subtitle: 'Mais de <span>25 mil recursos digitais</span> prontos para <b>professores e alunos</b>',
    landing_banner_explore_collections: 'Explorar coleções agora',
    landing_more_collections: 'Explorar todas as coleções',
    landing_education_title: 'Encontre o que você precisa de acordo com sua etapa educacional',
    landing_education_primary: 'Primeira infância',
    landing_education_basic: 'Pré-escola, ensino básico e médio',
    landing_education_superior: 'Educação superior',
    landing_education_work: 'Educação para o trabalho e desenvolvimento humano',
    landing_areas_title: 'Explore por áreas do conhecimento',
    landing_science_math_title: 'Ciências e Matemática',
    landing_science_math_description: 'Explore desde ciências básicas até aplicações técnicas.',
    landing_view_resources: 'Ver recursos ',
    landing_language_humanities_title: 'Linguagem, Humanidades e Sociedade',
    landing_language_humanities_description: 'Comunicação, história, filosofia e cidadania em um só lugar',
    landing_habits_title: 'Promova hábitos saudáveis e bem-estar integral.',
    landing_habits_description: 'Materiais para formação de professores e fortalecimento pedagógico.',
    landing_art_culture_title: 'Arte, Cultura e Expressão',
    landing_art_culture_description: 'Recursos para a expressão artística, a ética e a vida cultural.',
    landing_health_wellness_title: 'Saúde e Bem-estar',
    landing_health_wellness_description: 'Promova hábitos saudáveis e bem-estar integral.',
    landing_learn_how_to_learn: 'Escolha como você quer aprender',
    landing_joinus_title: 'Professores de todo o país já usam RED Aprende.',
    landing_joinus_subtitle: 'Junte-se e aproveite os recursos digitais disponíveis para sua sala de aula.',
    landing_banner_title_aria: 'Sección principal: Explore y enseñe con RED Aprende',
    landing_banner_explore_collections_aria: 'Explorar colecciones de la sección principal',
    landing_more_collections_aria: 'Explorar todas as coleções',
    landing_education_primary_aria: 'Fase educacional: Primeira infância',
    landing_education_basic_aria: 'Fase educacional: Pré-escola, ensino básico e médio',
    landing_education_superior_aria: 'Fase educacional: Educação superior',
    landing_education_work_aria: 'Fase educacional: Educação para o trabalho e desenvolvimento humano',
    landing_view_resources_science_aria: 'Ver recursos de Ciências e Matemática',
    landing_view_resources_language_aria: 'Ver recursos de Linguagem, Humanidades e Sociedade',
    landing_view_resources_habits_aria: 'Ver recursos de Hábitos saudáveis e bem-estar integral',
    landing_view_resources_art_aria: 'Ver recursos de Arte, Cultura e Expressão',
    landing_view_resources_health_aria: 'Ver recursos de Saúde e Bem-estar',
    landing_resource_format_textual_aria: 'Explorar recursos de formato textual',
    landing_resource_format_graphic_aria: 'Explorar recursos de formato gráfico',
    landing_resource_format_sonorous_aria: 'Explorar recursos de formato sonoro',
    landing_resource_format_audiovisual_aria: 'Explorar recursos de formato audiovisual',
    landing_resource_format_multimedia_aria: 'Explorar recursos de formato multimídia',
    landing_resource_format_interactive_aria: 'Explorar recursos de formato interativo',
    landing_resource_format_textual_alt: 'Ícone de recursos textuais',
    landing_resource_format_graphic_alt: 'Ícone de recursos gráficos',
    landing_resource_format_sonorous_alt: 'Ícone de recursos sonoros',
    landing_resource_format_audiovisual_alt: 'Ícone de recursos audiovisuais',
    landing_resource_format_multimedia_alt: 'Ícone de recursos multimídia',
    landing_resource_format_interactive_alt: 'Ícone de recursos interativos',

    // Textos de Objeto.js
    objeto_view_group_aria: 'Ver detalhes do grupo {{title}}',
    objeto_view_resource_aria: 'Ver detalhes do recurso {{title}}',
    objeto_image_alt: 'Imagem de pré-visualização para {{title}}',
    objeto_resources_count_aria: 'Número de recursos: {{count}}',
    objeto_resource_singular: 'recurso',
    objeto_resource_plural: 'recursos',
    objeto_average_rating_aria: 'Qualificação média: {{rating}} de 5 estrelas',
    objeto_view_collection_aria: 'Ver coleção',
    objeto_view_collection: 'Ver coleção'
  }
};

export default pt;
